module.exports = __webpack_public_path__ + "static/media/co2.682d1555.png";